import {
  HAPTIK_PARTNER_ID,
  INTERAKT_PARTNER_ID,
  THRIVE_PARTNER_ID,
} from "modules/App/constants/partners";

type storeType = {
  getState: Function;
};

export function validStoreInstance(store: storeType | any) {
  return (
    store &&
    typeof store === "object" &&
    store.getState &&
    typeof store.getState === "function"
  );
}

export function getPartnerName(partnerId: string | undefined) {
  if (partnerId === HAPTIK_PARTNER_ID) {
    return "Haptik";
  }

  if (partnerId === INTERAKT_PARTNER_ID) {
    return "Interakt";
  }

  if (partnerId === THRIVE_PARTNER_ID) {
    return "Thrive";
  }

  return partnerId;
}

/**
 * Removes null keys from the template object, except for "footer" and "template_category_label".
 * @param template - The template object to remove null keys from.
 * @returns The template object without null keys, except for "footer" and "template_category_label".
 */
export function deleteTemplateNullKeysExceptForFooterAndCategoryLabels<T>(
  template: Record<string, T> | null | undefined,
): Record<string, T> {
  if (template) {
    return Object.keys(template).reduce((acc, key) => {
      if (
        key === "footer" ||
        key === "template_category_label" ||
        template[key] !== null
      ) {
        acc[key] = template[key] as T;
      }

      return acc;
    }, {} as Record<string, T>);
  }

  return {};
}
